module.exports = __webpack_public_path__ + "h5/img/funv-top-banner.00e0b9db.jpg";